import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import '@/assets/scss/global.scss'

import VueTooltip from 'v-tooltip'
import VueModal from '@/plugins/Modal'
import VueGtag from 'vue-gtag'

if (process.env.CONTEXT === 'production') {
  Vue.use(VueGtag, {
    config: { id: process.env.CODE_UA },
  })
}

Vue.config.productionTip = false

Vue.use(VueTooltip)
Vue.use(VueModal)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#gtr-bot-demo')
